import functionListApi from '@/api/functionList/functionListApi'
import happyPackageApi from '@/api/happyPackage/happyPackageApi.js';

export default {
	name: 'function-list',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
      		getAppliedServicesResp:{
        		isVoLTEUser:'',
				voiceBasicServices:[],
				addServices:[]
			},
      		happyPackages: null,
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		// 若網址為 /Service#/xxx => 轉為 /Service/#/xxx
		/*
		const hash = window.location.hash;
		const href = window.location.href;
		const index = href.indexOf(hash);
		if(href.charAt(index - 1) != '/') {
			window.location.href = href.substring(0, index) + '/' + href.substring(index);
		} else {
			this.init();
		}
		*/
		this.redirectToEcHome();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
      // 查詢申裝服務
      this.getAppliedServicesResp = await functionListApi.getAppliedServices();

      // 列出快樂包服務
	  const getHappyPackageListResp = await happyPackageApi.getHappyPackageList();
			if (getHappyPackageListResp) {
				this.happyPackages = getHappyPackageListResp.happyPackages;
			}
		},
		redirectToEcHome() {
			window.location.href = '/ecare/#/'
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/functionList/functionList.js